'use client';

import { MemoryGame } from '@/contexts/games/components/memory/MemoryGame';
import '@/contexts/games/components/memory/styles/memory-game.css';

export default function MemoryGameClient() {
  return <MemoryGame />;
}
